import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'base64Image',
  standalone: true,
})
export class Base64ImagePipe implements PipeTransform {
  transform(base64String: string): string {
    if (!base64String) {
      return '';
    }

    return `data:image/png;base64,${base64String}`;
  }
}
